import { AxiosError } from "axios";

import httpRequest from "@/auth/http-client";

const baseConversationUrl = "api/v1/conversation";

export async function getUnreadConversationsCount(platformId: number): Promise<number> {
  try {
    const response = await httpRequest.get<Record<string, unknown>>(
      `${baseConversationUrl}/all/${platformId}/unread-count`
    );
    const payload =
      response && typeof response === "object" && "data" in response && response.data
        ? (response.data as Record<string, unknown>)
        : response;

    return Number(payload?.count ?? payload?.Count ?? 0) || 0;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return 0;
    }
    throw error;
  }
}
